<div
    class="loader-spinner"
    [style.--loader-size]="loaderSize()"
    [style.--spinner-top-color]="spinnerColor()"
    [style.--spinner-base-color]="baseColor()"
    [style.--spinner-border-size]="borderSize()"
></div>